module.exports = __webpack_public_path__ + "static/media/no_battery.19b3dca2.svg";